const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const KnowledgeWorkbench = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/Workbench');
const KnowledgeWorkflowDetail = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/KnowledgeWorkflowDetail');
const KnowledgeCreatePage = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/KnowledgeCreatePage');
const KnowledgeDetail = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/KnowledgeDetail');

export default [
  {
    path: '/knowledge-manage',
    name: 'knowledgeManage',
    meta: {
      roles: ['WF_KB_QUERY']
    },
    component: Layout,
    children: [
      {
        path: 'knowledge-bench',
        name: 'knowledgeBench',
        meta: {
          title: '知识管理',
          icon: 'knowledge-manage',
          activeMenu: '/knowledge-manage/knowledge-bench/',
          roles: ['WF_KB_QUERY'],
          componentName: 'KnowledgeWorkbench',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            }
          ]
        },
        component: KnowledgeWorkbench
      },
      {
        path: 'edit-knowledge-workflow/:id',
        props: true,
        name: 'editKnowledgeWorkflow',
        meta: {
          title: '处理知识',
          hidden: true,
          activeMenu: '/knowledge-manage/knowledge-bench',
          componentName: 'KnowledgeWorkflowDetail',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            },
            {
              name: '处理知识',
              path: '/knowledge-manage/edit-knowledge-workflow/:id'
            }
          ]
        },
        component: KnowledgeWorkflowDetail
      },
      {
        path: 'create-knowledge-workflow',
        name: 'createKnowledgeWorkflow',
        meta: {
          title: '新建知识单据',
          hidden: true,
          activeMenu: '/knowledge-manage/knowledge-bench',
          roles: ['WF_KB_ADD'],
          componentName: 'KnowledgeCreatePage',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            },
            {
              name: '新建知识单据',
              path: '/knowledge-manage/create-knowledge-workflow'
            }
          ]
        },
        component: KnowledgeCreatePage
      },
      {
        path: ':id/detail',
        props: true,
        name: 'knowledgeDetail',
        meta: {
          title: '知识详情',
          hidden: true,
          activeMenu: '/knowledge-manage/knowledge-bench',
          componentName: 'KnowledgeDetail',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            },
            {
              name: '知识详情',
              path: '/knowledge-manage/:id/detail'
            }
          ]
        },
        component: KnowledgeDetail
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/knowledgeManage.js